import { default as ai_45form_45builderQSVK7PVoqnMeta } from "/usr/code/docker/www/formx/client/pages/ai-form-builder.vue?macro=true";
import { default as editPNrkQS8g4GMeta } from "/usr/code/docker/www/formx/client/pages/forms/[slug]/edit.vue?macro=true";
import { default as indexI6XDk0E99GMeta } from "/usr/code/docker/www/formx/client/pages/forms/[slug]/index.vue?macro=true";
import { default as indexuueGggaVzdMeta } from "/usr/code/docker/www/formx/client/pages/forms/[slug]/show/index.vue?macro=true";
import { default as indexUtcz4Bo6QNMeta } from "/usr/code/docker/www/formx/client/pages/forms/[slug]/show/integrations/index.vue?macro=true";
import { default as share649Qs5MzH2Meta } from "/usr/code/docker/www/formx/client/pages/forms/[slug]/show/share.vue?macro=true";
import { default as statsJhQbRoYrYaMeta } from "/usr/code/docker/www/formx/client/pages/forms/[slug]/show/stats.vue?macro=true";
import { default as submissionswk8zrtka24Meta } from "/usr/code/docker/www/formx/client/pages/forms/[slug]/show/submissions.vue?macro=true";
import { default as showE0slzOt9hxMeta } from "/usr/code/docker/www/formx/client/pages/forms/[slug]/show.vue?macro=true";
import { default as guestaPLXNOtbPLMeta } from "/usr/code/docker/www/formx/client/pages/forms/create/guest.vue?macro=true";
import { default as index1fceqz3nfKMeta } from "/usr/code/docker/www/formx/client/pages/forms/create/index.vue?macro=true";
import { default as home1O5B5Y2J3QMeta } from "/usr/code/docker/www/formx/client/pages/home.vue?macro=true";
import { default as index8i8ZCcHRa5Meta } from "/usr/code/docker/www/formx/client/pages/index.vue?macro=true";
import { default as logine1lOd8XhVoMeta } from "/usr/code/docker/www/formx/client/pages/login.vue?macro=true";
import { default as callbackJPyazjYJZ7Meta } from "/usr/code/docker/www/formx/client/pages/oauth/callback.vue?macro=true";
import { default as emailedogU5VS4VMeta } from "/usr/code/docker/www/formx/client/pages/password/email.vue?macro=true";
import { default as _91token_93DInyvYllGXMeta } from "/usr/code/docker/www/formx/client/pages/password/reset/[token].vue?macro=true";
import { default as pricingZsooOtBLr9Meta } from "/usr/code/docker/www/formx/client/pages/pricing.vue?macro=true";
import { default as privacy_45policys2vIRf5hGGMeta } from "/usr/code/docker/www/formx/client/pages/privacy-policy.vue?macro=true";
import { default as registereg3v93APQ3Meta } from "/usr/code/docker/www/formx/client/pages/register.vue?macro=true";
import { default as access_45tokensTzmtjz9X5GMeta } from "/usr/code/docker/www/formx/client/pages/settings/access-tokens.vue?macro=true";
import { default as accounttJvXPQdnWDMeta } from "/usr/code/docker/www/formx/client/pages/settings/account.vue?macro=true";
import { default as adminffu2xwLtVmMeta } from "/usr/code/docker/www/formx/client/pages/settings/admin.vue?macro=true";
import { default as billingl9zVGrHXo1Meta } from "/usr/code/docker/www/formx/client/pages/settings/billing.vue?macro=true";
import { default as connectionsMB6mFz3FjjMeta } from "/usr/code/docker/www/formx/client/pages/settings/connections.vue?macro=true";
import { default as indexVcomesEsp6Meta } from "/usr/code/docker/www/formx/client/pages/settings/index.vue?macro=true";
import { default as passwordpqruADPtTyMeta } from "/usr/code/docker/www/formx/client/pages/settings/password.vue?macro=true";
import { default as profileH2VZalb3LxMeta } from "/usr/code/docker/www/formx/client/pages/settings/profile.vue?macro=true";
import { default as workspaceqtp5lcpsKiMeta } from "/usr/code/docker/www/formx/client/pages/settings/workspace.vue?macro=true";
import { default as settingsZhDfT6Uzu9Meta } from "/usr/code/docker/www/formx/client/pages/settings.vue?macro=true";
import { default as errorgafRqbC0GmMeta } from "/usr/code/docker/www/formx/client/pages/subscriptions/error.vue?macro=true";
import { default as successAlAqYm67JNMeta } from "/usr/code/docker/www/formx/client/pages/subscriptions/success.vue?macro=true";
import { default as _91slug_93YfvyABqQIgMeta } from "/usr/code/docker/www/formx/client/pages/templates/[slug].vue?macro=true";
import { default as indexKwhtjT71b0Meta } from "/usr/code/docker/www/formx/client/pages/templates/index.vue?macro=true";
import { default as _91slug_93EK3fpqLC7IMeta } from "/usr/code/docker/www/formx/client/pages/templates/industries/[slug].vue?macro=true";
import { default as my_45templates0P3DQtjTdMMeta } from "/usr/code/docker/www/formx/client/pages/templates/my-templates.vue?macro=true";
import { default as _91slug_93MfpDynxDs4Meta } from "/usr/code/docker/www/formx/client/pages/templates/types/[slug].vue?macro=true";
import { default as terms_45conditionsNP77uznYqkMeta } from "/usr/code/docker/www/formx/client/pages/terms-conditions.vue?macro=true";
import { default as update_45credentialstZtj1VGp7MMeta } from "/usr/code/docker/www/formx/client/pages/update-credentials.vue?macro=true";
export default [
  {
    name: "ai-form-builder",
    path: "/ai-form-builder",
    meta: ai_45form_45builderQSVK7PVoqnMeta || {},
    component: () => import("/usr/code/docker/www/formx/client/pages/ai-form-builder.vue").then(m => m.default || m)
  },
  {
    name: "forms-slug-edit",
    path: "/forms/:slug()/edit",
    meta: editPNrkQS8g4GMeta || {},
    component: () => import("/usr/code/docker/www/formx/client/pages/forms/[slug]/edit.vue").then(m => m.default || m)
  },
  {
    name: "forms-slug",
    path: "/forms/:slug()",
    component: () => import("/usr/code/docker/www/formx/client/pages/forms/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: showE0slzOt9hxMeta?.name,
    path: "/forms/:slug()/show",
    meta: showE0slzOt9hxMeta || {},
    component: () => import("/usr/code/docker/www/formx/client/pages/forms/[slug]/show.vue").then(m => m.default || m),
    children: [
  {
    name: "forms-slug-show",
    path: "",
    redirect: indexuueGggaVzdMeta?.redirect,
    component: () => import("/usr/code/docker/www/formx/client/pages/forms/[slug]/show/index.vue").then(m => m.default || m)
  },
  {
    name: "forms-slug-show-integrations",
    path: "integrations",
    meta: indexUtcz4Bo6QNMeta || {},
    component: () => import("/usr/code/docker/www/formx/client/pages/forms/[slug]/show/integrations/index.vue").then(m => m.default || m)
  },
  {
    name: "forms-slug-show-share",
    path: "share",
    meta: share649Qs5MzH2Meta || {},
    component: () => import("/usr/code/docker/www/formx/client/pages/forms/[slug]/show/share.vue").then(m => m.default || m)
  },
  {
    name: "forms-slug-show-stats",
    path: "stats",
    meta: statsJhQbRoYrYaMeta || {},
    component: () => import("/usr/code/docker/www/formx/client/pages/forms/[slug]/show/stats.vue").then(m => m.default || m)
  },
  {
    name: "forms-slug-show-submissions",
    path: "submissions",
    meta: submissionswk8zrtka24Meta || {},
    component: () => import("/usr/code/docker/www/formx/client/pages/forms/[slug]/show/submissions.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "forms-create-guest",
    path: "/forms/create/guest",
    meta: guestaPLXNOtbPLMeta || {},
    component: () => import("/usr/code/docker/www/formx/client/pages/forms/create/guest.vue").then(m => m.default || m)
  },
  {
    name: "forms-create",
    path: "/forms/create",
    meta: index1fceqz3nfKMeta || {},
    component: () => import("/usr/code/docker/www/formx/client/pages/forms/create/index.vue").then(m => m.default || m)
  },
  {
    name: "home",
    path: "/home",
    meta: home1O5B5Y2J3QMeta || {},
    component: () => import("/usr/code/docker/www/formx/client/pages/home.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    component: () => import("/usr/code/docker/www/formx/client/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "login",
    path: "/login",
    meta: logine1lOd8XhVoMeta || {},
    component: () => import("/usr/code/docker/www/formx/client/pages/login.vue").then(m => m.default || m)
  },
  {
    name: "oauth-callback",
    path: "/oauth/callback",
    alias: ["/oauth/:provider/callback"],
    component: () => import("/usr/code/docker/www/formx/client/pages/oauth/callback.vue").then(m => m.default || m)
  },
  {
    name: "password-email",
    path: "/password/email",
    meta: emailedogU5VS4VMeta || {},
    component: () => import("/usr/code/docker/www/formx/client/pages/password/email.vue").then(m => m.default || m)
  },
  {
    name: "password-reset-token",
    path: "/password/reset/:token()",
    meta: _91token_93DInyvYllGXMeta || {},
    component: () => import("/usr/code/docker/www/formx/client/pages/password/reset/[token].vue").then(m => m.default || m)
  },
  {
    name: "pricing",
    path: "/pricing",
    meta: pricingZsooOtBLr9Meta || {},
    component: () => import("/usr/code/docker/www/formx/client/pages/pricing.vue").then(m => m.default || m)
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: privacy_45policys2vIRf5hGGMeta || {},
    component: () => import("/usr/code/docker/www/formx/client/pages/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: "register",
    path: "/register",
    meta: registereg3v93APQ3Meta || {},
    component: () => import("/usr/code/docker/www/formx/client/pages/register.vue").then(m => m.default || m)
  },
  {
    name: settingsZhDfT6Uzu9Meta?.name,
    path: "/settings",
    meta: settingsZhDfT6Uzu9Meta || {},
    component: () => import("/usr/code/docker/www/formx/client/pages/settings.vue").then(m => m.default || m),
    children: [
  {
    name: "settings-access-tokens",
    path: "access-tokens",
    component: () => import("/usr/code/docker/www/formx/client/pages/settings/access-tokens.vue").then(m => m.default || m)
  },
  {
    name: "settings-account",
    path: "account",
    meta: accounttJvXPQdnWDMeta || {},
    component: () => import("/usr/code/docker/www/formx/client/pages/settings/account.vue").then(m => m.default || m)
  },
  {
    name: "settings-admin",
    path: "admin",
    meta: adminffu2xwLtVmMeta || {},
    component: () => import("/usr/code/docker/www/formx/client/pages/settings/admin.vue").then(m => m.default || m)
  },
  {
    name: "settings-billing",
    path: "billing",
    meta: billingl9zVGrHXo1Meta || {},
    component: () => import("/usr/code/docker/www/formx/client/pages/settings/billing.vue").then(m => m.default || m)
  },
  {
    name: "settings-connections",
    path: "connections",
    meta: connectionsMB6mFz3FjjMeta || {},
    alias: ["/settings/connections/callback/:service"],
    component: () => import("/usr/code/docker/www/formx/client/pages/settings/connections.vue").then(m => m.default || m)
  },
  {
    name: "settings",
    path: "",
    redirect: indexVcomesEsp6Meta?.redirect,
    component: () => import("/usr/code/docker/www/formx/client/pages/settings/index.vue").then(m => m.default || m)
  },
  {
    name: "settings-password",
    path: "password",
    meta: passwordpqruADPtTyMeta || {},
    component: () => import("/usr/code/docker/www/formx/client/pages/settings/password.vue").then(m => m.default || m)
  },
  {
    name: "settings-profile",
    path: "profile",
    meta: profileH2VZalb3LxMeta || {},
    component: () => import("/usr/code/docker/www/formx/client/pages/settings/profile.vue").then(m => m.default || m)
  },
  {
    name: "settings-workspace",
    path: "workspace",
    meta: workspaceqtp5lcpsKiMeta || {},
    component: () => import("/usr/code/docker/www/formx/client/pages/settings/workspace.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "subscriptions-error",
    path: "/subscriptions/error",
    meta: errorgafRqbC0GmMeta || {},
    component: () => import("/usr/code/docker/www/formx/client/pages/subscriptions/error.vue").then(m => m.default || m)
  },
  {
    name: "subscriptions-success",
    path: "/subscriptions/success",
    meta: successAlAqYm67JNMeta || {},
    component: () => import("/usr/code/docker/www/formx/client/pages/subscriptions/success.vue").then(m => m.default || m)
  },
  {
    name: "templates-slug",
    path: "/templates/:slug()",
    component: () => import("/usr/code/docker/www/formx/client/pages/templates/[slug].vue").then(m => m.default || m)
  },
  {
    name: "templates",
    path: "/templates",
    component: () => import("/usr/code/docker/www/formx/client/pages/templates/index.vue").then(m => m.default || m)
  },
  {
    name: "templates-industries-slug",
    path: "/templates/industries/:slug()",
    component: () => import("/usr/code/docker/www/formx/client/pages/templates/industries/[slug].vue").then(m => m.default || m)
  },
  {
    name: "templates-my-templates",
    path: "/templates/my-templates",
    meta: my_45templates0P3DQtjTdMMeta || {},
    component: () => import("/usr/code/docker/www/formx/client/pages/templates/my-templates.vue").then(m => m.default || m)
  },
  {
    name: "templates-types-slug",
    path: "/templates/types/:slug()",
    component: () => import("/usr/code/docker/www/formx/client/pages/templates/types/[slug].vue").then(m => m.default || m)
  },
  {
    name: "terms-conditions",
    path: "/terms-conditions",
    meta: terms_45conditionsNP77uznYqkMeta || {},
    component: () => import("/usr/code/docker/www/formx/client/pages/terms-conditions.vue").then(m => m.default || m)
  },
  {
    name: "update-credentials",
    path: "/update-credentials",
    component: () => import("/usr/code/docker/www/formx/client/pages/update-credentials.vue").then(m => m.default || m)
  }
]